module.exports = __webpack_public_path__ + "img/dimensao_vaos.b107de71.png";